import styled from "styled-components";
import {IconThumbUp} from "./IconThumbUp";

export const IconThumbDown = styled(IconThumbUp)`
    transform: rotate(180deg);
`;
